// Core Imports
import React, { useState } from 'react';
import { Container, Col, Row } from 'react-bootstrap';

// Assets
import Banner from '../../assets/images/aboutus/about-banner-long.jpeg';
import AboutExp1 from '../../assets/images/aboutus/about-exp-1s.jpeg';
import AboutExp2 from '../../assets/images/aboutus/about-exp-2s.jpeg';
import Mission from '../../assets/images/aboutus/about-mission-1s.jpeg';
import Gavin from '../../assets/images/team/gavin-1s.jpg';
import Dan from '../../assets/images/team/dan-1s.jpeg';
import Emma from '../../assets/images/team/emma-1s.jpg';
import Donato from '../../assets/images/team/donato-1s.jpg';
import Bryan from '../../assets/images/team/bryan-1s.jpeg';
import Fiona from '../../assets/images/team/fiona-1s.png';
import Design from '../../assets/images/des-1.png';

// Components
import { Carousel } from 'react-bootstrap';

const AboutUsPrint = () => {
  const [open, setOpen] = useState({});

  const toggleOpen = (key) => {
    setOpen((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <div>

      {/* Breadcrumbs Section */}
      <section
        id="breadcrumbs"
        className="breadcrumbs"
        style={{
          backgroundImage: `url(${Banner})`,
        }}
      >
        <div className="container">
          <h1>About Us</h1>
        </div>
      </section>

      {/* About Us Section */}
      <section className="entry">
        <Container>
          <Row>
            <Col md={5}>
              <div style={{ position: 'relative' }}>
                <div className="slider d-none d-sm-block">
                  <Carousel controls={false} interval={5000} fade>
                    <Carousel.Item>
                      <img
                        className="img-fluid my-auto"
                        src={AboutExp1}
                        alt="ready mix concrete delivery"
                      />
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className="img-fluid my-auto"
                        src={AboutExp2}
                        alt="batching plant in operation"
                      />
                    </Carousel.Item>
                  </Carousel>
                </div>
                <div className="info" style={{ zIndex: 2 }}>
                  <h4><span>5</span> Years of Experience</h4>
                </div>
              </div>
            </Col>
            <Col md={7}>
              <h2>About Us</h2>
              <h3>From concept to completion — earthworks to construction</h3>
              <p>Southern Alps Development Projects is a Te Anau–based construction company delivering integrated solutions across earthworks, civil works, residential and commercial construction.</p>
              <p>We started with earthworks and straightforward builds and have grown into a multi-skilled team capable of delivering complex, high-quality projects — including detailed interior fit-outs and remediation work. Today, we operate with in-house design, project management, construction crews, and earthworks operators, allowing us to manage projects from start to finish under one contract.</p>
              <p>Our focus is simple: clear communication, practical solutions, and building work that stands the test of time.</p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Mission Section */}
      <section className="section-bg">
        <Container>
          <Row className="justify-content-between">
            <Col md={6} className="my-auto">
              <h2>Mission</h2>
              <h3>Our Mission And Vision</h3>
              <p><strong>Our mission</strong> is to deliver safe, high-quality construction outcomes through practical planning, skilled workmanship, and clear communication — while meeting client expectations at every stage.</p>
              <p><strong>Our vision</strong> is to be a trusted construction partner in Te Anau basin — known for reliability, problem-solving, and consistently delivering projects that perform well, last long, and meet client’s expectations.</p>
            </Col>
            <Col md={5}>
              <img src={Mission} alt="SADP Mission" className="img-fluid my-auto" />
            </Col>
          </Row>
        </Container>
      </section>

    </div>
  );
};

export default AboutUsPrint;
